import LargeCard from './large-card';
export default LargeCard;